<template>
  <form @submit.prevent="save">
    <v-container fluid>
      <v-card-text>
        Ihre E-Mail Adresse muss bestätigt werden.
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          depressed
          :loading="loading"
          color="primary"
          type="submit"
        >
          Send again
        </v-btn>
      </v-card-actions>
    </v-container>
  </form>
</template>

<script>
export default {
   name: 'AuthResendVerification',
   components: {
      //
   },
   data () {
      return {
         loading: false,
      }
   },
   methods: {
      save () {
         this.loading = true
         this.$inertia.post('/email/verification-notification', {}).then(() => this.loading = false)
      },
   }
}
</script>

<style>

</style>
